import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useOnScreen } from '../../hooks';
import Label from './Label';

interface PasswordInputProps {
    value?: string;
    name?: string;
    placeholder?: string,
    required?: boolean,
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void,
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void,
    error?: string,
    forceError?: string,
    disabled?: boolean,
    label?: string,
    className?: string,
    'data-test-id'?: string,
}

function PasswordInput({ value, name, placeholder, required, onChange, onKeyDown, error, forceError, disabled, label, 'data-test-id': testId, className }: PasswordInputProps) {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const isVisible = useOnScreen(inputRef);
    const cls = `form__item _input _pass ${className || ''}`;
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (error && !isVisible) {
            const input = inputRef.current;
            const top = input?.offsetTop || 0;
            window.scrollTo(0, top - 40);
        }
        // eslint-disable-next-line
    }, [error]);

    return (
        <>
            {label && <Label>{label}</Label>}
            <div className={cls}>
                {/* <div style={{ display: 'inline-flex', width: 'calc(100% + 1rem)' }}> */}
                    <input
                        ref={inputRef}
                        type={showPassword ? 'text' : 'password'}
                        className={'form__input' + (((error && (!value && required)) || forceError) ? ' _error' : '')}
                        required={required}
                        value={value}
                        name={name}
                        placeholder={placeholder}
                        onChange={(e) => { onChange && onChange(e); }}
                        onKeyDown={onKeyDown}
                        disabled={disabled}
                        data-test-id={testId}
                        style={{ paddingRight: '2rem' }}
                    />
                    <div className={`form__pass-show${showPassword ? ' _active' : ''}`} onClick={() => setShowPassword(!showPassword)}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 10c2-4 5-6 9-6s7 2 9 6c-2 4-5 6-9 6s-7-2-9-6Z" stroke="#99A3B3" stroke-width="1.5" stroke-linejoin="round"></path><circle cx="10" cy="10" r="3" stroke="#99A3B3" stroke-width="1.5"></circle></svg>
                    </div>
                    {/* <span>
                        {showPassword ?
                            <NoEye width={'16px'} height={'16px'} style={{ position: 'relative', right: '1.5rem', top: '30%' }} onClick={() => setShowPassword(!showPassword)} />
                            :
                            <Eye width={'16px'} height={'16px'} style={{ position: 'relative', right: '1.5rem', top: '30%' }} onClick={() => setShowPassword(!showPassword)} />
                        }
                    </span> */}
                {/* </div> */}
                {(error && (!value && required)) && <span className="form__input-error-message">{error}</span>}
                {forceError && <span className="form__input-error-message">{forceError}</span>}
            </div>
        </>
    );
}

export default PasswordInput;